// extracted by mini-css-extract-plugin
export var actionButton = "_mk-t";
export var buttonContainer = "_mk-0";
export var buttonContainer2 = "_mk-1";
export var buttonSection = "_mk-2";
export var details = "_mk-3";
export var dropdownItem = "_mk-5";
export var dropdownItemsContainer = "_mk-4";
export var fileInput = "_mk-r";
export var headerButton = "_mk-6";
export var icon = "_mk-7";
export var input = "_mk-8";
export var macroListItem = "_mk-9";
export var mainContent = "_mk-a";
export var microText = "_mk-b";
export var modal = "_mk-w";
export var optionsButton = "_mk-c";
export var paperclip = "_mk-s";
export var pillContent = "_mk-d";
export var preview = "_mk-e";
export var preview2 = "_mk-f";
export var quillEditor = "_mk-q";
export var selectedMacro = "_mk-g";
export var sidebar = "_mk-h";
export var sidebarHeader = "_mk-j";
export var sidebarList = "_mk-i";
export var sidebarListItem = "_mk-k";
export var sidebarSearch = "_mk-l";
export var snoozeDurationWrapper = "_mk-v";
export var statusPillContainer = "_mk-m";
export var tagsContainer = "_mk-n";
export var unselectedMacro = "_mk-o";
export var variable = "_mk-u";
export var wrapper = "_mk-p";